import type { RouteRecordRaw } from 'vue-router'
import LayoutApp from '@/views/app/the-layout.vue'
import authRoutes from './auth'
import customerRoutes from './customer'
import productRoutes from './product'
import shopRoutes from './shop-order'
import tenantRoutes from './tenant'

const routes: RouteRecordRaw[] = [
  {
    path: '/app',
    component: LayoutApp,
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import('@/views/app/home/page-home.vue'),
        meta: { title: 'Home' },
      },
      {
        path: '/riwayat-perubahan',
        name: 'log',
        component: () => import('@/views/log/page-log.vue'),
        meta: { title: 'Riwayat Perubahan' },
      },
    ],
  },
  ...customerRoutes,
  ...productRoutes,
  ...shopRoutes,
  ...authRoutes,
  ...tenantRoutes,
]

export default routes
